<div class="flex flex-wrap gap-3 p-fluid"  style="justify-content:end">
<div class="grid">
    <div class="col">
        <label class="font-bold block mb-2">Start Date</label>
        <p-calendar [(ngModel)]="startDate" dateFormat="dd/mm/yy" [showButtonBar]="true" [maxDate]="maxDateValue"   (onSelect)="forAllFilterData()" />
    </div>
   <div class="col">
        <label class="font-bold block mb-2">End Date</label>
        <p-calendar [(ngModel)]="endDate" dateFormat="dd/mm/yy" [showButtonBar]="true" [maxDate]="maxDateValue1" [minDate]="minDateValue" (onSelect)="forAllFilterData()"/>
   </div>
</div>
</div>
<div class="flex flex-wrap">

    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0 bg-blue-200 hover:shadow-8 border-2 shadow-5" (click)="navigateTo('/view-purchase-order')">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-900 font-medium text-2xl mb-3"><strong>Purchase Order</strong></span>
                    <div class="text-900 font-medium text-3xl"><strong>{{poCount}}</strong></div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round mt-4" [ngStyle]="{width: '3.5rem', height: '3.5rem'}">
                    <!-- <i class="pi pi-shopping-cart "></i> -->
                    <i class="fa-solid fa-cart-shopping text-blue-500 text-5xl"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0 bg-orange-200 hover:shadow-8 border-2 shadow-5"  (click)="navigateTo('/portal/order/schedule')">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-900 font-medium text-2xl mb-3"><strong>Schedule</strong></span>
                    <div class="text-900 font-medium text-3xl"><strong>{{scheduleCount}}</strong></div>
                </div>
                <div class="flex align-items-center justify-content-center bg-orange-100 border-round mt-4" [ngStyle]="{width: '3.5rem', height: '3.5rem'}">
                    <!-- <i class="pi pi-map-marker "></i> -->
                    <i class="fa-solid fa-calendar-days text-orange-500 text-5xl"></i>
                </div>
            </div>

        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0 bg-green-200 hover:shadow-8 border-2 shadow-5" (click)="navigateTo('/portal/order/shipment')">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-900 font-medium text-2xl mb-3"><strong>Shipment</strong></span>
                    <div class="text-900 font-medium text-3xl"><strong>{{shipmentCount}}</strong></div>
                </div>
                <div class="flex align-items-center justify-content-center bg-green-100 border-round mt-4" [ngStyle]="{width: '3.5rem', height: '3.5rem'}">
                    <!-- <i class="pi pi-inbox "></i> -->
                    <i class="fa-solid fa-truck-fast text-green-500 text-5xl"></i>
                </div>
            </div>

        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0 bg-purple-200 hover:shadow-8 border-2 shadow-5" (click)="navigateTo('/gr')">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-900 font-medium text-2xl mb-3"><strong>Goods Receipt</strong></span>
                    <div class="text-900 font-medium text-3xl"><strong>{{grCount}}</strong></div>
                </div>
                <div class="flex align-items-center justify-content-center bg-purple-100 border-round mt-4" [ngStyle]="{width: '3.5rem', height: '3.5rem'}">
                    <!-- <i class="pi pi-comment "></i> -->
                    <i class="fa-solid fa-receipt text-purple-500 text-5xl"></i>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="flex flex-wrap">
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0 bg-red-200 hover:shadow-8 border-2 shadow-5"  (click)="navigateTo('/ir')">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-900 font-medium text-2xl mb-3"><strong>Invoice Receipt</strong></span>
                    <div class="text-900 font-medium text-3xl"><strong>{{irCount}}</strong></div>
                </div>
                <div class="flex align-items-center justify-content-center bg-red-100 border-round mt-4" [ngStyle]="{width: '3.5rem', height: '3.5rem'}">
                    <!-- <i class="pi pi-shopping-cart "></i> -->
                    <i class="fa-solid fa-file-invoice-dollar text-red-500 text-5xl"></i>
                </div>
            </div>

        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3" *ngIf="isVendorSuperAdmin">
        <div class="card mb-0 bg-yellow-200 hover:shadow-8 border-2 shadow-5" (click)="navigateTo('pending-vendor-list')">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-900 font-medium text-2xl mb-3"><strong>Pending Vendors</strong></span>
                    <div class="text-900 font-medium text-3xl"><strong>{{pendingvendorCount}}</strong></div>
                </div>
                <div class="flex align-items-center justify-content-center bg-yellow-100 border-round mt-4" [ngStyle]="{width: '3.5rem', height: '3.5rem'}">
                    <!-- <i class="pi pi-map-marker "></i> -->
                    <!-- <i class="fa-solid fa-clock-rotate-left "></i> -->
                    <i class="fa-solid fa-user-clock text-yellow-500 text-5xl"></i>
                </div>
            </div>
        </div>
    </div>
</div>

      <div class="grid">
        <div class="col-4">
            <!-- [style]="{'width':'30%'}" -->
            <p-card [style]="{'background-color': '#abc9fb','text-align':'center','color':'#111827'}" header="Purchase Order">

                <div class="grid">
                    <div class="col-12">
                        <div class="grid">
                            <div class="col">
                                <label class="font-bold block mb-2">Start Date</label>
                                <p-calendar [(ngModel)]="poStartDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="poFilterDate()" (ngModelChange)="poFilterDate()"/>
                            </div>
                           <div class="col">
                                <label class="font-bold block mb-2">End Date</label>
                                <p-calendar [(ngModel)]="poEndDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="poFilterDate()"/>
                           </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <p-chart type="doughnut" [data]="poChartData" [options]="poOptions" width="250" height="250"  />
                    </div>
                </div>

            </p-card>

        </div>
        <div class="col-4">

            <p-card [style]="{'background-color': '#fcc39b','text-align':'center','color':'#111827'}" header="Schedule">
                <div class="grid">
                    <div class="col-12">
                        <div class="grid">
                            <div class="col">
                                <label class="font-bold block mb-2">Start Date</label>
                                <p-calendar [(ngModel)]="scheduleStartDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="scheduleFilterDate()" />
                            </div>
                           <div class="col">
                                <label class="font-bold block mb-2">End Date</label>
                                <p-calendar [(ngModel)]="scheduleEndDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="scheduleFilterDate()"/>
                           </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <p-chart type="doughnut" [data]="scheduleChartData" [options]="scheduleOptions" width="250" height="250"  />
                    </div>
                </div>

            </p-card>
        </div>
        <div class="col-4">
            <!-- [style]="{'width':'30%'}" -->
            <p-card [style]="{'background-color': '#a0e6ba','text-align':'center','color':'#111827'}" header="Shipment">
                <div class="grid">
                    <div class="col-12">
                        <div class="grid">
                            <div class="col">
                                <label class="font-bold block mb-2">Start Date</label>
                                <p-calendar [(ngModel)]="shipmentStartDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="shipmentFilterDate()" />
                            </div>
                           <div class="col">
                                <label class="font-bold block mb-2">End Date</label>
                                <p-calendar [(ngModel)]="shipmentEndDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="shipmentFilterDate()"/>
                           </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <p-chart type="doughnut" [data]="shipmentChartData" [options]="shipmentOptions" width="250" height="250"  />
                    </div>
                </div>

            </p-card>

        </div>

        <!-- <div class="grid"> -->
            <div class="col-4">
                <p-card [style]="{'background-color': '#dab6fc','text-align':'center','color':'#111827'}" header="Goods Receipt">
                    <div class="grid">
                        <div class="col-12">
                            <div class="grid">
                                <div class="col">
                                    <label class="font-bold block mb-2">Start Date</label>
                                    <p-calendar [(ngModel)]="grStartDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="grFilterDate()" />
                                </div>
                               <div class="col">
                                    <label class="font-bold block mb-2">End Date</label>
                                    <p-calendar [(ngModel)]="grEndDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="grFilterDate()"/>
                               </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <p-chart type="doughnut" [data]="grChartData" [options]="grOptions" width="250" height="250"  />
                        </div>
                    </div>

                </p-card>
            </div>
            <div class="col-4">

                <p-card [style]="{'background-color': '#ffaca7','text-align':'center','color':'#111827'}" header="Invoice Receipt">
                    <div class="grid">
                        <div class="col-12">
                            <div class="grid">
                                <div class="col">
                                    <label class="font-bold block mb-2">Start Date</label>
                                    <p-calendar [(ngModel)]="irStartDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="irFilterDate()" />
                                </div>
                               <div class="col">
                                    <label class="font-bold block mb-2">End Date</label>
                                    <p-calendar [(ngModel)]="irEndDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="irFilterDate()"/>
                               </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <p-chart type="doughnut" [data]="irChartData" [options]="irOptions" width="250" height="250"  />
                        </div>
                    </div>

                </p-card>
            </div>
            <!-- <div class="col">

            </div> -->

      </div>


<!-- <div class="container"> -->
    <!-- <div class="card1 flex card">
        <p-chart type="bar" [data]="shipment" [options]="shipmentOptions"   class="p-chart" />
    </div> -->
    <!-- <div class="card flex ">
        <p-chart type="bar" [data]="shipment" [options]="shipmentOptions"   class="p-chart" />
    </div> -->
<!-- </div> -->
